import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-red.svg'


const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-row items-center gap-3 w-full mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center gap-3"
}
const _hoisted_4 = { class: "flex flex-row justify-between border-b py-3 px-4" }
const _hoisted_5 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "up"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_8 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_11 = {
  class: "mt-5 flex relative w-full overflow-auto",
  style: {"max-height":"34rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bulkBooking.client.label'),
      class: "w-full"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_SelectSearch, {
            isFirstInput: true,
            options: _ctx.clients,
            onFocus: _ctx.onSearchValue,
            onFilter: _ctx.onSearchValue,
            keyName: "name",
            keyValue: "id",
            placeholder: _ctx.$t('bulkBooking.client.placeholder'),
            modelValue: _ctx.modelValue.clientName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.clientName = $event)),
            isLoading: _ctx.isLoadingClients,
            onChange: _ctx.onChageClientName,
            isShowErrorMessage: false,
            isShowErrorIndicator: _ctx.isErrorClient || _ctx.errorMandatory,
            errorCaption: 
            _ctx.errorMandatory
              ? _ctx.$t('bulkBooking.client.errorMandatory')
              : _ctx.$t('bulkBooking.client.errorBooking')
          ,
            class: "w-full",
            isDisabled: _ctx.disabled,
            disabledBackground: _ctx.disabled
          }, null, 8, ["options", "onFocus", "onFilter", "placeholder", "modelValue", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "isDisabled", "disabledBackground"]),
          _createVNode(_component_button_outline, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShowPopupFilterClient(true))),
            title: _ctx.$t('bulkBooking.client.buttonList'),
            custom: "border-gray-lp-600 text-gray-lp-300 bg-white",
            style: {"height":"38px","min-width":"130px"},
            iconLeft: "ics_o_contactNote",
            isDisabled: _ctx.disabled
          }, null, 8, ["title", "isDisabled"])
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    (_ctx.showPopupFilterClient)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-8/12",
          showBorderTitle: false,
          showFooter: false,
          scrollable: false,
          title: _ctx.$t('bulkBooking.client.modalTitle'),
          onClose: () => _ctx.onClosePopupFilter()
        }, {
          content: _withCtx(() => [
            (!_ctx.isErrorGetClient)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode(_component_AdvancedFilter, {
                    "custom-max-height": "60vh",
                    "model-value": _ctx.filterClient,
                    isDisabled: false,
                    onOpened: _ctx.onOpenedAdvancedFilter,
                    onReset: ($event: any) => (
              {
              }
            ),
                    addSumFilter: _ctx.sumFilter,
                    showIconFilter: true,
                    showCountFilter: false,
                    showChevron: false,
                    isSeparateContent: "",
                    customTitleFilter: "text-14px font-semibold text-gray-lp-300"
                  }, {
                    "custom-filter": _withCtx(() => [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("bulkBooking.client.filter.searchTitle")), 1),
                        _hoisted_6
                      ]),
                      _createVNode("div", _hoisted_7, [
                        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("bulkBooking.client.filter.cityOrigin")), 1),
                        _createVNode(_component_SelectSearchV2, {
                          onFilter: _ctx.fetchCityDestination,
                          onFocus: _ctx.fetchCityDestination,
                          isLoading: _ctx.loadingCityDestination,
                          options: _ctx.cityDestinationData,
                          keyName: "name",
                          keyValue: "name",
                          placeholder: 
                    _ctx.$t('bulkBooking.client.filter.cityOriginPlaceholder')
                  ,
                          modelValue: _ctx.filterClient.cityOriginCode,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                            _ctx.onChangeCityDestination
                          ]
                        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _hoisted_9,
                        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("bulkBooking.client.filter.shipmentType")), 1),
                        _createVNode(_component_MultipleSelectSearch, {
                          onChange: _ctx.onChangeShipmentType,
                          status: "active",
                          class: "my-1.5",
                          options: _ctx.optionsProduct,
                          placeholder: 
                    _ctx.$t('bulkBooking.client.filter.shipmentTypePlaceholder')
                  ,
                          modelValue: _ctx.filterClient.shipmentType,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                        }, null, 8, ["onChange", "options", "placeholder", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model-value", "onOpened", "addSumFilter"]),
                  _createVNode(_component_Search, {
                    class: "w-full",
                    onInput: (search) => _ctx.onSearchValue(search, true),
                    onClear: _ctx.clearSearch,
                    value: _ctx.searchValue,
                    placeholder: _ctx.$t('bulkBooking.client.searchPlaceholder'),
                    colorIcon: "#4D4D4D"
                  }, null, 8, ["onInput", "onClear", "value", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                onRequest: _cache[5] || (_cache[5] = 
              () =>
                _ctx.fetchdDataClients({ isDirectory: true, infiniteScroll: true })
            ),
                data: _ctx.clients,
                loading: _ctx.isLoadingClients,
                errorCause: _ctx.isErrorGetClient,
                isDetailAble: "",
                onClick: (item) => _ctx.goToDetail(item),
                paginationStyle: "v3",
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => (_ctx.pagination = $event)),
                borderTop: false,
                borderBottom: false,
                isEmpty: _ctx.isEmpty,
                bgHeader: "bg-white",
                hidePagination: "",
                isNoPaddingBottom: "",
                infiniteScroll: ""
              }, null, 8, ["columns", "data", "loading", "errorCause", "onClick", "pagination", "isEmpty"])
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}